export const technicalSheet = {
	sections: {
		generalInfo: {
			title: "GENERAL INFORMATION",
			preparationTime: {
				label: "Preparation time",
				placeholder: "00 minutes",
				unit: "minutes",
			},
		},
		ingredients: {
			title: "INGREDIENTS",
			addButton: "Add to sheet",
			emptyState: {
				title: "No ingredients added",
				message: "Add ingredients to compose the technical sheet",
			},
			inline: {
				product: "Product/Ingredient",
				quantity: "Quantity",
				loss: "Losses",
			},
			columns: {
				product: "PRODUCT/INGREDIENT",
				quantity: "QUANTITY",
				loss: "LOSS",
				yield: "YIELD",
				unitCost: "UNIT COST.",
				unitCostTooltip: "Unit cost is the average of all product costs",
				totalCost: "TOTAL COST",
				totalCostTooltip: "Total cost is the average cost of all products",
			},
			validation: {
				selectProduct: "Select an ingredient",
				addQuantity: "Add a quantity",
				lossGreaterThanQuantity: "The loss value cannot be greater than the quantity",
				atLeastOneIngredient: "Add at least one ingredient to the technical sheet",
				quantityGreaterThanZero: "The value must be greater than 0",
			},
		},
	},
	summary: {
		salePrice: "Sale price",
		totalCost: "Total cost",
		totalCostTooltip: "Total cost is the average cost of all products",
		profitMargin: "Profit margin",
		cmv: "CMV",
	},
	actions: {
		delete: "Delete technical sheet",
		exportPdf: "Export PDF",
		deleteConfirmation: {
			title: "Delete technical sheet",
			description:
				"By confirming this action you permanently delete the technical sheet. Do you want to continue?",
			confirm: "Yes, I want to delete",
			cancel: "Cancel",
		},
		notifications: {
			deleteSuccess: "Technical sheet removed successfully",
			deleteError: "Error removing the technical sheet",
		},
	},
};
